// أنواع البيانات الخاصة بالمتجر الإلكتروني

import { InventoryItem, Customer } from '../utils/types';

// عنوان العميل المحفوظ
export interface CustomerAddress {
  id: string;
  label: string;          // اسم العنوان (المنزل، العمل، إلخ)
  fullName: string;
  phone: string;
  email?: string;
  address: string;
  city: string;
  region: string;
  building?: string;
  floor?: string;
  apartment?: string;
  // Bosta fields
  bostaCityId?: string;
  bostaCityName?: string;
  bostaZoneId?: string;
  bostaZoneName?: string;
  bostaDistrictId?: string;
  bostaDistrictName?: string;
  // تفضيلات
  defaultShippingMethod?: string;
  defaultPaymentMethod?: string;
  isDefault: boolean;
  createdAt: Date;
}

// نموذج سلة التسوق
export interface CartItem {
  productId: string;
  product: InventoryItem;
  quantity: number;
}

export interface Cart {
  items: CartItem[];
  customerId?: string;
  totalAmount: number;
  totalItems: number;
}

// نموذج الطلب
export enum OrderStatus {
  PENDING = 'pending',
  PROCESSING = 'processing',
  SHIPPED = 'shipped',
  DELIVERED = 'delivered',
  CANCELLED = 'cancelled'
}

export enum PaymentStatus {
  PENDING = 'pending',
  PAID = 'paid',
  FAILED = 'failed',
  REFUNDED = 'refunded'
}

export enum PaymentMethod {
  CASH_ON_DELIVERY = 'cash_on_delivery',
  BANK_TRANSFER = 'bank_transfer',
  ELECTRONIC_PAYMENT = 'electronic_payment'
}

export interface ShippingDetails {
  address: string;
  city: string;
  region: string;
  postalCode?: string;
  phone: string;
  shippingMethod: string;
  shippingCost: number;
  estimatedDeliveryDate?: Date;
  firstName?: string;
  lastName?: string;
  street?: string;
  building?: string;
  floor?: string;
  apartment?: string;
  // Bosta fields
  bostaCityName?: string;
  bostaCityId?: string;
  bostaZoneName?: string;
  bostaZoneId?: string;
  bostaDistrict?: string;
  bostaDistrictId?: string;
}

export interface OrderItem {
  productId: string;
  productName: string;
  productSku: string;
  quantity: number;
  price: number;
  total: number;
  warehouseId: string;
}

export interface Order {
  id: string;
  orderNumber: string;
  customerId: string;
  customerName: string;
  customerPhone: string;
  customerEmail: string;
  items: OrderItem[];
  subtotal: number;
  shippingCost: number;
  discount: number;
  tax: number;
  total: number;
  paymentMethod: PaymentMethod;
  paymentStatus: PaymentStatus;
  orderStatus: OrderStatus;
  shippingDetails: ShippingDetails;
  notes?: string;
  cancellationReason?: string;
  createdAt: Date;
  updatedAt: Date;
  processedAt?: Date;
  shippedAt?: Date;
  deliveredAt?: Date;
  cancelledAt?: Date;
  // Bosta integration
  bostaDeliveryId?: string;
  bostaTrackingNumber?: number;
  bostaState?: number;
  bostaStateName?: string;
  bostaPricing?: {
    subtotal: number;
    discount: number;
    vat: number;
    total: number;
  };
  bostaCreatedAt?: string;
  bostaWaybillUrl?: string;
  bostaExceptionReason?: string;
}

export interface ShippingCity {
  id: string;
  name: string;
  shippingCost: number;
  estimatedDeliveryDays: number;
  isActive: boolean;
}

// نموذج المنطقة للشحن
export interface ShippingRegion {
  id: string;
  name: string;
  cost: number;
  estimatedDeliveryDays: number;
  isActive: boolean;
  cities?: ShippingCity[];
}

// نموذج شركة الشحن
export interface ShippingCompany {
  id: string;
  name: string;
  logo?: string;
  regions: ShippingRegion[];
  isActive: boolean;
}

// نموذج المراجعة
export interface Review {
  id: string;
  productId: string;
  customerId: string;
  customerName: string;
  rating: number; // 1-5
  comment: string;
  createdAt: Date;
  isApproved: boolean;
}
